import { Series } from '../series/chart-series';
import { TechnicalAnalysis } from './indicator-base';
/**
 * The `MomentumIndicator` module is used to render the Momentum indicator.
 */
export class MomentumIndicator extends TechnicalAnalysis {
    /**
     * Defines the collection of series to represent a momentum indicator.
     *
     * @private
     * @param {TechnicalIndicator} indicator - The technical indicator for which the series collection is initialized.
     * @param {Chart} chart - The chart associated with the technical indicator.
     * @returns {void}
     */
    initSeriesCollection(indicator, chart) {
        super.initSeriesCollection(indicator, chart);
        const upperLine = new Series(indicator, 'targetSeries', {}, true);
        super.setSeriesProperties(upperLine, indicator, 'UpperLine', indicator.upperLine.color, indicator.upperLine.width, chart);
    }
    /**
     * Defines the predictions using momentum approach
     *
     * @private
     * @param {TechnicalIndicator} indicator - The technical indicator for which the data source is to be initialized.
     * @returns {void}
     */
    initDataSource(indicator) {
        const upperCollection = [];
        const signalCollection = [];
        const validData = indicator.points;
        if (validData && validData.length) {
            const upperSeries = indicator.targetSeries[1];
            const signalSeries = indicator.targetSeries[0];
            const length = indicator.period;
            if (validData.length >= indicator.period) {
                for (let i = 0; i < validData.length; i++) {
                    upperCollection.push(this.getDataPoint(validData[i].x, 100, validData[i], upperSeries, upperCollection.length));
                    if (!(i < length)) {
                        signalCollection.push(this.getDataPoint(validData[i].x, (Number(validData[i].close) / Number(validData[i - length].close) * 100), validData[i], signalSeries, signalCollection.length));
                    }
                }
            }
            this.setSeriesRange(signalCollection, indicator, indicator.targetSeries[0]);
            this.setSeriesRange(upperCollection, indicator, indicator.targetSeries[1]);
        }
    }
    /**
     * To destroy the momentum indicator.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroys the momentum indicator.
         */
    }
    /**
     * Get module name.
     *
     * @returns {string} - Returns the module name.
     */
    getModuleName() {
        /**
         * Returns the module name of the series.
         */
        return 'MomentumIndicator';
    }
}
